import { render, staticRenderFns } from "./ReferralEdit.vue?vue&type=template&id=52b861f0&scoped=true&"
import script from "./ReferralEdit.vue?vue&type=script&lang=ts&"
export * from "./ReferralEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ReferralEdit.vue?vue&type=style&index=0&id=52b861f0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b861f0",
  null
  
)

export default component.exports